<div *ngIf="question">
  <lms-toolbar>
    <div class="lms-toolbar__item">
      <gl-button icon icon-center="glicon-trash" (onClick)="deleteQuestion()"></gl-button>
    </div>
  </lms-toolbar>
  <div class="heading-section">{{ 'customizations.documents.questions.detail.title' | translate }}</div>
  <div class="col s12">
    <lms-question-editor [question]="question" (onSave)="onUpdateQuestion($event)"> </lms-question-editor>
  </div>
</div>
